import { FETCH_ALL_POSTS } from '../../constants/endpoints';
import request from '../request';

const getAllPosts = async ({ until, after, studentPost } = {}) => {
  const { data, status } = await request({
    method: 'get',
    url: FETCH_ALL_POSTS({ until, after, studentPost }),
  });
  if (status !== 200) throw new Error(`Posts fetch non 200: ${status}`);
  return data;
};

export default getAllPosts;
